import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smartmail_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalize Pydantic 422 validation errors (array of {type, loc, msg, ...})
    // into a single string so callers can safely pass `err.response.data.detail`
    // to toast.error() / JSX without crashing React.
    const d = err?.response?.data?.detail;
    if (d !== undefined && d !== null && typeof d !== "string") {
      if (Array.isArray(d)) {
        err.response.data.detail = d
          .map((e) => {
            if (typeof e === "string") return e;
            const field = Array.isArray(e?.loc) ? e.loc.filter(p => p !== "body").join(".") : "";
            const msg = e?.msg || "validation error";
            return field ? `${field}: ${msg}` : msg;
          })
          .join(" • ");
      } else if (typeof d === "object") {
        err.response.data.detail = d.msg || JSON.stringify(d);
      }
    }
    if (err?.response?.status === 401) {
      localStorage.removeItem("smartmail_token");
      localStorage.removeItem("smartmail_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const AI_CATEGORIES = {
  important: { label: "Important", className: "bg-red-100 text-red-700 border-red-200" },
  urgent: { label: "Urgent", className: "bg-orange-100 text-orange-700 border-orange-200" },
  administrative: { label: "Admin", className: "bg-blue-100 text-blue-700 border-blue-200" },
  commercial: { label: "Commercial", className: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  newsletter: { label: "Newsletter", className: "bg-purple-100 text-purple-700 border-purple-200" },
  promotion: { label: "Promo", className: "bg-pink-100 text-pink-700 border-pink-200" },
  spam: { label: "Spam", className: "bg-gray-100 text-gray-700 border-gray-200" },
  system: { label: "Système", className: "bg-slate-100 text-slate-700 border-slate-200" },
};
